import deepmerge from 'deepmerge';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'PageSection' })(theme => deepmerge({
	paddingWrapper: {
		paddingLeft: 20,
		paddingRight: 20,
		[theme.breakpoints.up('sm')]: {
			paddingLeft: 30,
			paddingRight: 30
		},
		[theme.breakpoints.up('md')]: {
			paddingLeft: 37,
			paddingRight: 37
		},
		[theme.breakpoints.up('lg')]: {
			paddingLeft: 96,
			paddingRight: 96
		}
	},
	maxWidthWrapper: {
		width: '100%',
		marginLeft: 'auto',
		marginRight: 'auto',
		[theme.breakpoints.up('xs')]: {
			maxWidth: 'unset',
			'&.mobile': {
				maxWidth: 600
			}
		},
		[theme.breakpoints.up('md')]: {
			maxWidth: 'unset',
			'&.desktop': {
				maxWidth: 1482
			}
		}
	}
}, theme.Skoda?.overrides?.SkodaPageSection ?? {}));

export type PageSectionProps = React.HTMLAttributes<HTMLDivElement> & {
	classes?: Partial<ReturnType<typeof useStyles>['classes']>;
	maxMobileWidth?: boolean;
	maxDesktopWidth?: boolean;
};

export const PageSection = React.forwardRef<HTMLDivElement, PageSectionProps>((props, ref) => {
	const { children, className, classes, maxDesktopWidth: restrictDesktopWidth, maxMobileWidth: restrictMobileWidth, ...other } = props;

	let { classes: styles, cx } = useStyles(undefined, { props: { classes } });

	return (
		<div ref={ref} {...other} className={cx(styles.paddingWrapper, className)}>
			<div className={cx(styles.maxWidthWrapper, restrictMobileWidth && 'mobile', restrictDesktopWidth && 'desktop')}>
				{children}
			</div>
		</div>
	);
});

PageSection.defaultProps = {
	maxMobileWidth: false,
	maxDesktopWidth: true
};
